var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skill-icon-canvas",on:{"click":function($event){return _vm.$emit('click', $event)},"hover":function($event){return _vm.$emit('hover', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }